module.exports = __webpack_public_path__ + "27960adef4c3cb1e0e4ce84b10f9c093.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/articlelinkimage_4.jpg
// module id = 297
// module chunks = 0